import { SignedPrintAuthorization } from "@/Common/Models/SignedPrintAuthorization";
import { OverlayElement, OverlayElementType } from "./OverlayElement";

export class SignPrintAuthorizationOverlayElement extends OverlayElement {
    public SignedPrintAuthorization: SignedPrintAuthorization;

    public constructor(init?: Partial<SignPrintAuthorizationOverlayElement>) {
        super(OverlayElementType.SignedPrintAuthorization);
        Object.assign(this, init);
    }
}
